export default __webpack_public_path__ + "static/media/about2.67b4b7a3.png";